import { useCallback, useEffect, useState } from 'react';
import { commerciauxApi, type MoiCommercial } from '../../lib/commerciauxApi';

/**
 * Qui regarde le module : la direction (titulaire ou collaborateur avec le droit « commissions »), un commercial (ses dossiers
 * seulement) ou quelqu'un d'autre. Lu une seule fois par visite et partagé par le menu latéral et les pages du module.
 */
let enCours: Promise<MoiCommercial> | null = null;
export const chargerMoiCommerciaux = (forcer = false): Promise<MoiCommercial> => {
    if (!enCours || forcer) enCours = commerciauxApi.moi().catch((e) => { enCours = null; throw e; });
    return enCours;
};

export function useMoiCommerciaux(actif = true) {
    const [moi, setMoi] = useState<MoiCommercial | null>(null);
    const [erreur, setErreur] = useState<unknown>(null);
    const charger = useCallback(async () => {
        setErreur(null);
        try { setMoi(await chargerMoiCommerciaux(true)); } catch (e) { setErreur(e); }
    }, []);
    useEffect(() => {
        if (!actif) return;
        let vivant = true;
        chargerMoiCommerciaux().then((m) => { if (vivant) setMoi(m); }).catch((e) => { if (vivant) setErreur(e); });
        return () => { vivant = false; };
    }, [actif]);
    return { moi, erreur, recharger: charger, direction: moi?.role === 'direction' };
}
